// @flow

import { THEME_STORAGE_KEY } from "constants/theme";

import type { ThemeMode } from "types/theme";

export function resolveThemeMode(storedTheme: ?string): ThemeMode {
  if (storedTheme === "light" || storedTheme === "dark") {
    return storedTheme;
  }

  if (typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }

  return "light";
}

export function getInitialThemeMode(): ThemeMode {
  if (typeof document === "undefined") {
    return "light";
  }

  const { documentElement } = document;

  if (documentElement === null) {
    return resolveThemeMode(localStorage.getItem(THEME_STORAGE_KEY));
  }

  const fromDocument = documentElement.getAttribute("data-bs-theme");

  if (fromDocument === "light" || fromDocument === "dark") {
    return fromDocument;
  }

  return resolveThemeMode(localStorage.getItem(THEME_STORAGE_KEY));
}

export function applyThemeMode(theme: ThemeMode): void {
  const { documentElement } = document;

  if (documentElement === null) {
    return;
  }

  documentElement.setAttribute("data-bs-theme", theme);

  const meta = document.querySelector('meta[name="theme-color"]');

  if (meta !== null) {
    meta.setAttribute("content", theme === "dark" ? "#212529" : "#f8f9fa");
  }
}
